// FAQ Schema Fixer - Consolidates multiple FAQPage schemas into one (place in assets folder!)
document.addEventListener('DOMContentLoaded', function() {
  // Find all FAQPage schema script tags
  const schemaScripts = Array.from(document.querySelectorAll('script[type="application/ld+json"]'))
    .filter(script => {
      try {
        const content = JSON.parse(script.textContent);
        return content && content['@type'] === 'FAQPage';
      } catch (e) {
        return false;
      }
    });
  
  // If there's only one or none, no need to fix
  if (schemaScripts.length <= 1) return;
  
  // Create a combined schema object
  const combinedSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    'mainEntity': []
  };
  
  // Extract and combine all questions
  schemaScripts.forEach(script => {
    try {
      const content = JSON.parse(script.textContent);
      if (content.mainEntity && Array.isArray(content.mainEntity)) {
        combinedSchema.mainEntity = combinedSchema.mainEntity.concat(content.mainEntity);
      }
    } catch (e) {
      console.error('Error processing schema:', e);
    }
  });
  
  // Remove all but the first schema script
  for (let i = 1; i < schemaScripts.length; i++) {
    schemaScripts[i].remove();
  }
  
  // Replace the content of the first script with the combined schema
  schemaScripts[0].textContent = JSON.stringify(combinedSchema);
  
  console.log('FAQ Schema Fixer: Combined ' + schemaScripts.length + ' schemas into one');
});